var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return [_c('a',{attrs:{"href":"http://www.huijipt.cn/private.html","target":"_blank"}},[_vm._v("隐私")]),_c('a',{attrs:{"href":"http://www.huijipt.cn/user.html","target":"_blank"}},[_vm._v("条款")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }